import CurrencyExchangeClient from './currency-exchange-client';
import CurrencyExchangeManager from './currency-exchange-manager';

export default angular
    .module('paysera.currencyExchange.services', [])
    .service('currencyExchangeClient', CurrencyExchangeClient)
    .service('currencyExchangeManager', CurrencyExchangeManager)
    .name
;
